import React from 'react'
import { useState, useEffect } from 'react';
import styled from 'styled-components';
import TextField from '@mui/material/TextField';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { useGetAssetsQuery, useEditAddAssetMutation } from '../../../../features/addassets/addassetApiSlice'
import { HeadingWrap, Span, CommonButton, PreDataWrap, IntReqWrapper, AddRemarkButton, BackButtonSpan } from '../../../../Styles/CommonStyles'
import PdfModal from '../../../../data/pdfmodal';
import fetchPDF from '../../../../data/fetchPDF';
import useAuth from '../../../../features/hooks/useAuth';
import { useSelector } from 'react-redux';


const Container = styled.div`
width: 100%;
`
const Wrapper = styled.div`
padding: 5px;
display: flex;
flex-direction: column;
`
const SelectContainer = styled.div`
margin: 15px;
display: flex;
align-items: center;
`
const Option = styled.option`
font-size: 15px;
font-weight: 100;
`
const BackArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
  cursor: pointer;
`
const Styledlabel = styled.label`
width: 25%;
margin-right: 10px;
font-size: 30px;
font-weight: 300;
`
const CatSelect = styled.select`
width: 40%;
height: 35px;
`
const SubcatSelect = styled.select`
width: 40%;
height: 30px;
`
const SpecSpan = styled.span`
font-size: 30px;
font-weight: 300;
`
const SpecificationContainer = styled.div`
height: 60vh;
border-radius: 10px;
width: 100%;
margin-top: 25px;
display: flex;
flex-direction: column;
`
const Specwrapper = styled.div`
width: 100%;
display: flex;
flex-wrap: wrap;
`
const SpecItemwrapper = styled.div`
width: 100%;
padding: 15px;
display: flex;
align-items: center;
`
const StyledForm = styled.form`
display: flex;
flex-direction: column;
padding: 10px;
`
const SpecLabel = styled.label`
width:150px;
margin-right: 10px;
font-size: 20px;
font-weight: 150;
`
const SpectSelect = styled.select`
width: 20vw;
height: 25px;
margin: 10px;
display: flex;
align-items: center;
`
const StyledButton = styled.button`
font-size: 20px;
background-color: teal;
display: flex;
align-items: center;
align-content: center;
width: 100px;
height: 50px;
border-radius: 5px;
align-self: flex-end;
margin-right: 50px;
margin-bottom: 20px;
`
const SubmitButton = styled.button`
font-size: 20px;
background-color: teal;
display: flex;
align-items: center;
align-content: center;
width: 100px;
height: 50px;
border-radius: 5px;
align-self: center;
`
const AsetfmContainer = styled.div`
width: 100%;
height: 100%;
`
const AsetfmWrapper = styled.div`
width: 100%;
height: 100%;
display: flex;
`
const LeftAsetfmWrapper = styled.div`
width:50%;
height: 100%;
flex: 1;
`
const RightAsetfmWrapper = styled.div`
width:50%;
height: 100%;
flex: 1;
`
const InputAsetfmWrapper = styled.div`
margin: 10px;
display:flex;
`
const TagsContainer = styled.div`
height: 30vh;
width: 100%;
overflow-y: scroll;  
`
const TagsAsetfmWrapper = styled.div`
display: flex;
`

const FormTabCont = styled.div`
`
const FormCont = styled.div``

const FirstpageForm = styled.form``

const EditButton = styled.button`
font-size: 20px;
background-color: teal;
display: flex;
align-items: center;
align-content: center;
width: 100px;
height: 50px;
border-radius: 5px;
align-self: flex-end;
margin-right: 50px;
margin-bottom: 20px;
cursor: pointer;
`

const Pfduploadlabel = styled.div`
  /* Add your desired button styles */
  background-color: #4caf50; /* Green */
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  margin-right:5px;
  cursor: pointer;
`
const ViewButton = styled.button`
  background-color: #4caf50; /* Green */
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  margin-right:5px;
  margin-left: 5px;
  cursor: pointer;  
`

const FilenameSpan = styled.span `
  display: flex;
  align-items: center;
  justify-content: center;
`
// setSelectedFile
const PreviewEdit = ({setFinalobj,setSelectedFile, fetchPDF, reqid,setreqId, setBclick, setSubmittedEditClick, setClicked}) => {
  
  const [finalSubClicked, setFinalSubClicked] = useState(false)
  const [editClicked, setEditclicked] = useState(true)
  const [addassetObj, setAddAsssetObj] = useState()
  const [selectedprfile, setSelectedprFile] = useState(null)
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [fileName, setFileName] = useState("");

  // Get auth token for API requests
  const token = useSelector(state => state.auth.token);

  const { getasset } = useGetAssetsQuery('assetlist', {
    selectFromResult: ({ data }) => ({
      getasset: data?.entities[reqid]
    }),
  })

  console.log(getasset)

  // Using use effect to store addasset object pertaining to reqid.
  useEffect(() =>{
    if(getasset && reqid){
      setAddAsssetObj(getasset);
    }
  },[getasset,reqid])

  // Using use effect to fetch pdf
  useEffect(() =>{
    const fetchandSetPdf = async () =>{
      if(addassetObj){
        try {
          const file = await fetchPDF(addassetObj, token);
          if(file){
            setSelectedprFile(file);
          }
        } catch (error) {
          console.error("Error fetching PDF file:", error);
        }
      }
    }
    fetchandSetPdf();   
  },[addassetObj, token])
  console.log(selectedprfile)
   
  const handleEditClick = async (e) => {
    e.preventDefault()
    setEditclicked(false)
    setSubmittedEditClick('')
    setBclick("edit")
    setreqId(addassetObj.id)
    setFinalobj(addassetObj);
    setClicked(false);
    const file = await fetchPDF(addassetObj, token)
    setSelectedFile(file);
  }

  const handleBackClcik = () => {
    setBclick('submitted')
    setSubmittedEditClick('')
  }
  const handleviewFile = () =>{
    setModalIsOpen(true)
  }
  const  closeModal = () =>{
    setModalIsOpen(false);
  } 

  return (
    <Container>
      <BackArrowContainer onClick={handleBackClcik}><ArrowLeftIcon /><BackButtonSpan >Back to Category Table</BackButtonSpan></BackArrowContainer>
      {addassetObj && <Wrapper>
        <FormTabCont>
          <FormCont>
            <SelectContainer>
              <TextField
                disabled={true}
                variant="outlined"
                style={{ width: '400px' }}
                inputProps={{ style: { height: '38px' } }}
                InputLabelProps={{ shrink: true }}
                value={addassetObj?.pur_store} label="Store Office" size="small"  />
            </SelectContainer>
            <SelectContainer>
              <TextField
                disabled={true}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                style={{ width: '400px' }}
                inputProps={{ style: { height: '38px' } }}
                value={addassetObj?.category}
                label="Category"
                size="small"
              />              
            </SelectContainer>
            <SelectContainer>
              <TextField
                disabled={true}
                variant="outlined"
                style={{ width: '400px' }}
                inputProps={{ style: { height: '38px' } }}
                InputLabelProps={{ shrink: true }}
                value={addassetObj?.name}
                label="Asset"
                size="small"
              />
            </SelectContainer>
            { <><HeadingWrap><Span>Details of Asset</Span></HeadingWrap> <SpecificationContainer>
              <Specwrapper><FirstpageForm>
                { Object.entries(addassetObj?.specification)?.map((elm) => (<SpecItemwrapper>
                  <TextField
                    disabled={true}
                    variant="outlined"
                    style={{ width: '400px' }}
                    inputProps={{ style: { height: '38px' } }}
                    InputLabelProps={{ shrink: true }}
                    value={elm[1]}
                    label={`${elm[0]}`}
                    size="small"
                  />
                </SpecItemwrapper>))}
              </FirstpageForm></Specwrapper>
              <AsetfmContainer>
                <StyledForm >
                  <AsetfmWrapper>
                    <LeftAsetfmWrapper>
                      <InputAsetfmWrapper>
                        <TextField
                          disabled={true}
                          style={{ width: '400px' }}
                          inputProps={{ style: { height: '38px' } }}
                          InputLabelProps={{ shrink: true }}
                          value={addassetObj?.unit_price} name='unit_price' label="Unit Cost" size="small" variant="outlined" />
                      </InputAsetfmWrapper>
                      <InputAsetfmWrapper>
                        <TextField
                          disabled={true}
                          variant="outlined"
                          style={{ width: '400px' }}
                          inputProps={{ style: { height: '38px' } }}
                          InputLabelProps={{ shrink: true }}
                          value={addassetObj?.oem}
                          label="Brand/OEM"
                          size="small"
                        />         
                      </InputAsetfmWrapper>

                      <InputAsetfmWrapper>
                        <TextField
                          disabled={true}
                          variant="outlined"
                          style={{ width: '400px' }}
                          inputProps={{ style: { height: '38px' } }}
                          InputLabelProps={{ shrink: true }}
                          value={addassetObj?.model_no}
                          label="Model No."
                          size="small"
                        /> 
                      </InputAsetfmWrapper>
                      
                      <InputAsetfmWrapper>
                        <TextField
                          disabled={true}
                          variant="outlined"
                          style={{ width: '400px' }}
                          inputProps={{ style: { height: '38px' } }}
                          InputLabelProps={{ shrink: true }}
                          value={addassetObj?.vendor}
                          label="Vendor"
                          size="small"
                        /> 
                      </InputAsetfmWrapper>
                      <InputAsetfmWrapper>
                        <TextField
                          disabled={true}
                          variant="outlined"
                          style={{ width: '400px' }}
                          inputProps={{ style: { height: '38px' } }}
                          InputLabelProps={{ shrink: true }}
                          value={addassetObj?.olderAssetsLot}
                          label="Is this Lot of assets already with users?"
                          size="small"
                        />  
                        </InputAsetfmWrapper>
                      <InputAsetfmWrapper>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={['DatePicker', 'DatePicker']}>
                            <DateTimePicker
                              label="Purchase date"
                              value={dayjs(addassetObj?.purchase_date)}
                              format="DD/MM/YYYY hh:mm a"
                              required={finalSubClicked}
                              disabled={true}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                      </InputAsetfmWrapper>
                      <InputAsetfmWrapper>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={['DatePicker', 'DatePicker']}>
                            <DateTimePicker
                              label="Installation date"
                              value={dayjs(addassetObj?.installation_date)}
                              format="DD/MM/YYYY hh:mm a"
                              required={finalSubClicked}
                              disabled={true}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                      </InputAsetfmWrapper>
                      <InputAsetfmWrapper>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={['DatePicker', 'DatePicker']}>
                            <DateTimePicker
                              label="warranty validity date"
                              value={dayjs(addassetObj?.warrantyexp_date)}
                              format="DD/MM/YYYY hh:mm a"
                              required={finalSubClicked}
                              disabled={true}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                      </InputAsetfmWrapper>
                      <InputAsetfmWrapper>
                        <TextField
                          style={{ width: '400px' }}
                          inputProps={{ style: { height: '38px' } }}
                          InputLabelProps={{ shrink: true }}
                          value={addassetObj?.ledge_ref} name='ledge_ref'  label="Any ledger Ref. No." size="small"
                          disabled={true} variant="outlined" />
                      </InputAsetfmWrapper>
                      <InputAsetfmWrapper>
                        <TextField
                          style={{ width: '400px' }}
                          inputProps={{ style: { height: '38px' } }}
                          InputLabelProps={{ shrink: true }}
                          value={addassetObj?.bill_ref} name='bill_ref'  label="Billing Ref. No." size="small"
                          disabled={true} variant="outlined" />
                      </InputAsetfmWrapper>
                      <InputAsetfmWrapper>
                        <TextField
                          style={{ width: '400px' }}
                          inputProps={{ style: { height: '38px' } }}
                          InputLabelProps={{ shrink: true }}
                          disabled={true}
                          value={addassetObj?.remarks} name='remarks'  label="Remarks" size="small" variant="outlined" />
                      </InputAsetfmWrapper>

                      <InputAsetfmWrapper>

                      <Pfduploadlabel>Contract Document</Pfduploadlabel>
                      {selectedprfile ? <><FilenameSpan>{ selectedprfile.name }</FilenameSpan><ViewButton type='button' onClick={handleviewFile}>View File</ViewButton></>:<FilenameSpan>No File Uploaded!</FilenameSpan>}
                      </InputAsetfmWrapper>

                    </LeftAsetfmWrapper>
                    <RightAsetfmWrapper>
                      <InputAsetfmWrapper>
                        <TextField
                          style={{ width: '400px' }}
                          inputProps={{ style: { height: '38px' } }}
                          InputLabelProps={{ shrink: true }}
                          required={true}
                          type='number'
                          disabled={true}
                          value={addassetObj.quantity}                          
                          label="Quantity" size="small" variant="outlined" />
                      </InputAsetfmWrapper>
                      <TagsContainer>
                        {addassetObj?.tags?.map((elm, ind) => (<TagsAsetfmWrapper key={ind}><InputAsetfmWrapper key={`OEM${ind}`}>
                          <TextField
                            style={{ width: '250px' }}
                            inputProps={{ style: { height: '38px' } }}
                            InputLabelProps={{ shrink: true }}
                            required={finalSubClicked}
                            disabled={editClicked}
                            value={elm?.oem_tag} label={`OEM Tag ${ind + 1}`} size="small" variant="outlined" />
                        </InputAsetfmWrapper>
                          <InputAsetfmWrapper key={`ORG${ind}`}>
                            <TextField
                              style={{ width: '250px' }}
                              inputProps={{ style: { height: '38px' } }}
                              InputLabelProps={{ shrink: true }}
                              disabled={editClicked}
                              value={elm?.org_tag} label={`ORG Tag ${ind + 1}`} size="small" variant="outlined" />
                          </InputAsetfmWrapper>
                        </TagsAsetfmWrapper>))}
                      </TagsContainer>
                    </RightAsetfmWrapper>
                  </AsetfmWrapper>
                  {getasset?.curr_editstatus === true && <EditButton onClick={handleEditClick}>Edit</EditButton>}
                </StyledForm>
              </AsetfmContainer>
            </SpecificationContainer ></>}
          </FormCont>
        </FormTabCont>
      </Wrapper >}
      <PdfModal
      show = {modalIsOpen}
      onClose = {closeModal}
      pdfUrl = {selectedprfile? URL.createObjectURL(selectedprfile):null}
      />
    </Container >
  )
}

export default PreviewEdit